module.exports = __webpack_public_path__ + "img/login-button.e245c1a4.png";